import DOMPurify from 'dompurify';

/** Browser-only sanitizer so Node tests can render the display components. */
export function sanitizeDisplayHtml(text: string): string {
  if (typeof window === 'undefined') {
    return text;
  }
  return DOMPurify.sanitize(text);
}
